import React, { useEffect, useState, useRef } from 'react';
/**
 * LongDivisionRenderer — Wrapper adapting LongDivision to renderer interface.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 */
import { QuestionRendererProps } from './types';
import { LongDivision } from '../LongDivision';
import { useEdgeTriggeredSubmit } from './useEdgeTriggeredSubmit';
export function LongDivisionRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const [answerPayload, setAnswerPayload] = useState('');
  useEdgeTriggeredSubmit(answerPayload, shouldValidate, onAnswer, question.id);
  const handleComplete = (userAnswer: string) => {
    setAnswerPayload(userAnswer);
  };
  return <LongDivision question={question} onComplete={handleComplete} onReadyChange={onReadyChange} shouldValidate={shouldValidate} data-id="element-10594" />;
}